<template>

    <el-container class="invoice-document-page invoice-editor-lighter">
        <el-header>
            <div>
                <el-button :aria-label="$t('common.back')" @click.native.prevent="goBack" class="el-icon-arrow-left"></el-button>
                <span class="invoice-document-add-title">{{$t('createEstimate.pageTitlePrefix')}} {{documentName}}</span>
            </div>
            <div>

                <el-button @click.native.prevent="createInvoice" type="success"
                           :disabled="!initialDataLoaded || buttonDisabledStatus || saveRequestPending" :loading="saveRequestPending">
                    <span v-if="tabIndex!='2'">{{$t('common.saveAndClose')}}</span>
                    <span v-else>{{$t('common.saveAndSendEmail')}}</span>
                </el-button>

            </div>
        </el-header>
        <el-main>
            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <div v-if="initialDataLoaded" class="invoice-editor-layout">

                <el-tabs class="invoice-left-tabs" type="border-card" style="width: 100%" @tab-click="clickTab" v-loading="loginLoading">
                    <el-tab-pane :label="$t('invoiceCreate.tabCreate')">
                        <div class="invoice-editor-left">
                            <div class="invoice-left-section-heading">
                                {{$t('invoiceCreate.sectionClient')}}
                            </div>

                            <div v-if="createClientDivStatus === 0">
                                <el-button class="invoice-left-add-button" style="margin-top: 20px;margin-bottom: 20px;margin-left: 3%;border-radius: 9px;"
                                           @click.native.prevent="openClientDialog">
                                    <div style="display: flex;  align-items: center;">
                                        <img data-v-02689aca="" src="@/static/icon/add_invoice_client.svg" alt="" width="28px" style="padding-right: 10px">
                                        <span style="font-size: 18px;color: #007AFF">{{$t('invoiceCreate.addClient')}}</span>
                                    </div>
                                </el-button>
                            </div>
                            <div v-else-if="createClientDivStatus === 1">

                                <div class="invoice-left-client-card-wrap" style="margin: 2% 3% 2% 3%;">
                                    <el-row>
                                        <el-col>
                                            <el-card class="invoice-client-card invoice-hover-card">
                                                <div class="invoice-client-card-body" style="line-height: 25px;">
                                                    <div class="invoice-client-info">
                                                        <span class="invoice-client-name">{{clientInfo.name}}<br></span>
                                                        <div v-if="clientInfo.billingAddressLine1!=''" class="invoice-client-address-row">{{clientInfo.billingAddressLine1}}</div>
                                                        <div v-if="clientInfo.phone!='' || clientInfo.clientEmail!=''" class="invoice-client-contact-row">
                                                            <span v-if="clientInfo.phone!=''">{{clientInfo.phone}}</span>
                                                            <span v-if="clientInfo.phone!='' && clientInfo.clientEmail!=''" class="invoice-client-contact-divider">|</span>
                                                            <span v-if="clientInfo.clientEmail!=''">{{clientInfo.clientEmail}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="invoice-card-actions">
                                                        <el-button class="invoice-client-action-button" style="padding-top: 0px" type="text" @click.native.prevent="openClientDialog">
                                            <span style="font-size: 16px">{{$t('common.edit')}}</span>
                                        </el-button>
                                        <el-button class="invoice-client-action-button" @click.native.prevent="deleteChooseClient()" type="text" style="color: red;padding-top: 0px">
                                            <span style="font-size: 16px">{{$t('common.cancel')}}</span>
                                        </el-button>
                                                    </div>
                                                </div>
                                            </el-card>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>

                            <el-dialog class="aaa client-info-dialog add-document-client-dialog" :title="$t('invoiceCreate.dialogClientInfo')" :visible.sync="clientDialogStatus" width="760px">
                                <el-form class="client-dialog-form" label-width="110px" :model="clientInfo" label-position="left">
                                    <div class="client-dialog-section-title">
                                        <span>{{$t('invoiceCreate.basicInformation')}}</span>
                                    </div>
                                    <el-form-item :label="$t('invoiceCreate.labelName')" prop="name">
                                        <el-autocomplete class="clientSelect" popper-class="client-autocomplete-popper add-document-client-autocomplete-popper invoice-editor-lighter" v-model="clientInfo.name"
                                                         :autofocus='true'
                                                         :fetch-suggestions="querySearchClientList"
                                                         @select="searchClientSelect"
                                                         :placeholder="$t('invoiceCreate.placeholderCreateOrSelect')">
                                            <template slot-scope="{ item }">
                                                <div class="client-suggestion">
                                                    <div class="client-suggestion-title">
                                                        <strong v-if="item.value">{{item.value}}</strong>
                                                        <span v-if="item.value && item.clientEmail"> - </span>
                                                        <span v-if="item.clientEmail">{{item.clientEmail}}</span>
                                                    </div>
                                                    <div class="client-suggestion-address">{{item.billingAddressLine1}}</div>
                                                </div>
                                            </template>
                                        </el-autocomplete>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelEmail')" prop="clientEmail">
                                        <el-input type="textarea" autosize v-model="clientInfo.clientEmail"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelPhone')">
                                        <el-input type="textarea" autosize v-model="clientInfo.phone"></el-input>
                                    </el-form-item>
                                    <div class="client-dialog-section-title">
                                        <span>{{$t('invoiceCreate.billingAddress')}}</span>
                                    </div>
                                    <el-form-item :label="$t('invoiceCreate.labelLine1')">
                                        <el-input type="textarea" autosize v-model="clientInfo.billingAddressLine1"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelLine2')">
                                        <el-input type="textarea" autosize v-model="clientInfo.billingAddressLine2"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelLine3')">
                                        <el-input type="textarea" autosize v-model="clientInfo.billingAddressLine3"></el-input>
                                    </el-form-item>

                                    <template v-if="!isPurchaseOrder">
                                        <div class="client-dialog-section-title">
                                            <span>{{$t('invoiceCreate.shippingAddress')}}</span>
                                        </div>
                                        <el-form-item :label="$t('invoiceCreate.labelShippingName')">
                                            <el-input type="textarea" autosize v-model="clientInfo.shippingName"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('invoiceCreate.labelLine1')">
                                            <el-input type="textarea" autosize v-model="clientInfo.shippingAddressLine1"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('invoiceCreate.labelLine2')">
                                            <el-input type="textarea" autosize v-model="clientInfo.shippingAddressLine2"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('invoiceCreate.labelLine3')">
                                            <el-input type="textarea" autosize v-model="clientInfo.shippingAddressLine3"></el-input>
                                        </el-form-item>
                                    </template>


                                    <el-form-item :label="$t('invoiceCreate.labelNotes')">
                                        <el-input type="textarea" autosize v-model="clientInfo.note"

                                                  :placeholder="$t('invoiceCreate.placeholderClientNotes')"></el-input>
                                    </el-form-item>

                                </el-form>

                                <div slot="footer" class="dialog-footer client-dialog-footer">
                                    <el-button @click="cancelClientDialog">{{$t('common.cancel')}}</el-button>
                                    <el-button type="primary" @click="closeClientDialog()">{{$t('common.save')}}</el-button>
                                </div>
                            </el-dialog>

                            <div class="itemTitle invoice-left-section-heading invoice-items-heading">
                                <span style="color: #000000">{{$t('invoiceCreate.sectionItems')}}</span>
                                <span class="invoice-save-item-setting">{{$t('invoiceCreate.saveToYourItem')}}
                                    <el-switch v-model="saveNewItemToItem" :active-value=1
                                               :inactive-value=0></el-switch>
                                </span>
                            </div>
                            <div>
                                <!--添加商品-->
                                <div v-for="(value,index) in itemList " :key="index">
                                    <div class="invoice-item-card" style="margin-left: 3%;border: 1px solid #E5E5EA;border-radius: 8px;margin-right: 3%;margin-top: 20px;" v-if="itemList[index].syncStatus!=1">

                                        <div class="invoice-item-card-body" style="padding-left: 2%">
                                            <div class="invoice-item-description">
                                                <el-autocomplete popper-class="invoice-item-autocomplete-popper add-document-item-autocomplete-popper invoice-editor-lighter"
                                                                 type="textarea" :autosize="{minRows: 1}" :placeholder="userSetting.descriptionLabel"
                                                                 v-model="itemList[index].itemDescription" :fetch-suggestions="querySearchItemList"
                                                                 @keydown.up.native.capture="handleItemDescriptionArrow"
                                                                 @keydown.down.native.capture="handleItemDescriptionArrow"
                                                                 @select="((item)=>{searchItemSelect(item, index)})">
                                                    <template slot-scope="{ item }">
                                                        <div class="invoice-item-suggestion">
                                                            <div class="invoice-item-suggestion-title">
                                                                <strong v-if="item.itemCode">{{item.itemCode}}</strong>
                                                                <span v-if="item.itemCode"> - </span>
                                                                <span>{{item.value}}</span>
                                                            </div>
                                                            <div class="invoice-item-suggestion-meta">
                                                                <span>{{xiaoshudianfenge1(item.rate, userSetting)}}</span>
                                                                <template v-if="item.isShowInventory === 1">
                                                                    <span>·</span>
                                                                    <span>{{$t('invoiceCreate.stock')}} {{item.inventoryNumber}}</span>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </el-autocomplete>
                                                <i class="invoice-item-search-icon el-icon-search" aria-hidden="true"></i>
                                            </div>
                                            <div v-if="userSetting.isShowProduceCode === 1" class="invoice-item-code-row">
                                                <div style="margin-top: 10px" class="sub-title">{{userSetting.codeLabel}}</div>
                                                <el-input :placeholder="$t('invoiceCreate.placeholderItemCode')" class="quantityClass"

                                                          v-model="itemList[index].itemCode"></el-input>
                                            </div>
                                            <div class="invoice-item-summary">
                                                <div class="invoice-item-inputs">
                                                    <div class="invoice-item-field">
                                                        <div style="margin-top: 10px;" class="sub-title">{{userSetting.quantityLabel}}</div>
                                                        <el-input class="quantityClass" @keyup.native="formatUnsignedAmountNow1" @blur="formatItemCountNumberBlur(index,itemList)"
                                                                  :placeholder="$t('invoiceCreate.placeholderQuantity')" onfocus="this.select()" v-model="itemList[index].quantity">
                                                        </el-input>
                                                    </div>
                                                    <span class="invoice-item-multiply">x</span>
                                                    <div class="invoice-item-field">
                                                        <div style="margin-top: 10px" class="sub-title">{{userSetting.rateLabel}}</div>
                                                        <el-input :placeholder="$t('invoiceCreate.placeholderRate')" class="quantityClass"
                                                                  @keyup.native="formatSignedRateNow1"
                                                                  @blur="formatItemRateNumberBlur(index,itemList)"
                                                                  onfocus="this.select()"
                                                                  v-model="itemList[index].rate"></el-input>
                                                    </div>
                                                </div>
                                                <span class="invoice-item-total"> {{ xiaoshudianfenge1(computeItemAfterItemDiscountOriginMoney(itemList[index]),userSetting)}}</span>
                                            </div>

                                            <!--税-->
                                            <div style="display: flex;justify-content:space-between;align-items:flex-start; ">
                                                <el-popover placement="top-start" width="520"
                                                            popper-class="invoice-tax-popover invoice-editor-lighter">

                                                    <div class="tax-panel">
                                                        <div class="tax-panel-row tax-panel-tax-row" v-for="taxInfo in itemList[index].everyTaxInfoList" :key="taxInfo.newInnerUUID">
                                                            <span class="tax-panel-label">{{taxInfo.taxName}}</span>
                                                            <el-select popper-class="invoice-editor-lighter" class="tax-rate-select" v-model="taxInfo.chooseRate">
                                                                <el-option
                                                                        v-for="taxRate in taxInfo.haveRateList"
                                                                        :key="taxRate"
                                                                        :label="(parseFloat((taxRate*100).toFixed(4)))+'%'"
                                                                        :value=taxRate></el-option>
                                                                <el-option :label="$t('common.close')" value="-1"></el-option>
                                                            </el-select>
                                                        </div>

                                                        <div class="tax-panel-row tax-panel-withholding-row" v-if="userSetting.withHoldingActive === 1 && !isPurchaseOrder">
                                                            <el-checkbox class="tax-panel-checkbox" :true-label=1 :false-label=0 v-model="itemList[index].everyItemWithholdingStatus">
                                                                <span class="tax-panel-label">{{userSetting.withHoldingTaxName}} {{" ("+parseFloat((userSetting.withHoldingTaxRate*100.0).toFixed(6))+"%)"}}</span>
                                                            </el-checkbox>
                                                        </div>

                                                        <div v-if="!isPurchaseOrder" class="tax-panel-row tax-panel-discount-row">
                                                            <span class="tax-panel-label">{{$t('common.discount')}}</span>
                                                            <div class="discount-control">
                                                                <el-radio-group class="discount-type-group" v-model="itemList[index].everyItemDiscountType" size="mini">
                                                                    <el-radio-button label="0">$</el-radio-button>
                                                                    <el-radio-button label="1">%</el-radio-button>
                                                                </el-radio-group>
                                                                <el-input class="itemDiscountClass discount-input" onfocus="this.select()"
                                                                          :placeholder="$t('invoiceCreate.placeholderRate')" @keyup.native="formatUnsignedAmountNow1"
                                                                          @blur="formatEveryItemDiscount(index,itemList)"
                                                                          v-model="itemList[index].everyItemDiscount"></el-input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <el-button class="tax-panel-trigger" type="text" slot="reference">
                                                        {{isPurchaseOrder ? $t('invoiceCreate.tax') : $t('invoiceCreate.taxDiscountWithholding')}}
                                                    </el-button>
                                                </el-popover>
                                                <el-button class="invoice-item-delete-button" @click.native.prevent="deleteItem(index,itemList[index])" type="text" style="margin-right: 7%;color: red">
                                                    <i class="el-icon-delete"></i>
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <el-button class="invoice-left-add-button" style="margin-top: 20px;margin-bottom: 20px;margin-left: 3%;border-radius: 9px;" @click.native.prevent="openAddItemDiarg">
                                    <div style="display: flex;  align-items: center;">
                                        <img src="@/static/icon/add_invoice_item.svg" alt="" width="28px" style="padding-right: 10px">
                                        <span style="color: #007AFF;font-size: 18px;">{{$t('invoiceCreate.addItem')}}</span>
                                    </div>
                                </el-button>
                            </div>

                            <div class="itemTitle invoice-left-section-heading">
                                <span style="color: #000000">{{$t('invoiceCreate.sectionAttachments')}}</span>
                            </div>
                            <div>
                                <div v-for="file in fileList" :key="file.innerUUID">
                                    <div class="attachment-card invoice-hover-card" v-if="file.syncStatus!=1" style="margin-left: 3%;border: 1px solid #E5E5EA;border-radius: 8px;margin-right: 3%;margin-top: 10px;">
                                        <!--显示的缩略图-->
                                        <div class="attachment-card-body" style="display: flex; align-items:flex-end;margin-top: 15px;margin-left: 3%;margin-bottom: 15px">
                                            <div class="attachment-card-content">
                                                <el-image
                                                        class="attachment-thumbnail"
                                                        :src="file.url"
                                                        :preview-src-list="[file.url]"
                                                        fit="cover">
                                                    <div slot="placeholder" class="remote-image-loading">
                                                        <i class="el-icon-loading"></i>
                                                    </div>
                                                </el-image>
                                                <div class="attachment-inputs" style="margin-left: 2%">
                                                    <el-input type="textarea" style="border-style: none none solid none;border-bottom: 1px solid #DCDFE6;width: 100%;" :autosize="{minRows: 1}" v-model="file.attachmentName"></el-input>
                                                    <el-input type="textarea" style="border-style: none none solid none;border-bottom: 1px solid #DCDFE6;width: 100%;" :autosize="{minRows: 1}" :placeholder="$t('invoiceCreate.placeholderInputDescription')" v-model="file.attachmentDesciption"></el-input>
                                                </div>
                                            </div>
                                            <div class="invoice-card-actions attachment-delete-column">
                                                <el-button class="attachment-delete-button" style="padding-bottom: 0px;color: red;" @click="handleRemove(file.innerUUID)" type="text">
                                                    <i class="el-icon-delete"></i>
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--上传s3博客 https://my.oschina.net/u/3955926/blog/1940499-->
                                <div class="invoice-left-upload-button-wrap" style="margin-top: 20px;margin-bottom: 20px;margin-left: 3%;">
                                    <el-upload
                                            multiple
                                            :action=requestURL
                                            :show-file-list="false"
                                            :on-success="handleSuccess"
                                            :on-error="handleUploadError"
                                            :before-upload="onBeforeUpload"
                                            :data="uploadData"
                                            accept="image/jpeg,image/png,image/bmp">
                                        <el-button class="invoice-left-add-button" style="border-radius: 9px;" :loading="attachPhotosStatus">
                                            <div style="display: flex;  align-items: center;">
                                                <img src="@/static/icon/add_invoice_attach.svg" alt="" width="28px" style="padding-right: 10px">
                                                <span style="color: #007AFF;font-size: 18px">{{$t('invoiceCreate.addPhoto')}}</span>
                                            </div>
                                        </el-button>
                                    </el-upload>
                                </div>
                            </div>

                            <div class="invoice-left-section-heading">
                                {{$t('invoiceCreate.sectionComment')}}
                            </div>
                            <el-input class="commentInput" style="font-size: 16px;border-bottom-style: solid;margin-left: 3%;width: 90%;padding: 0px;border-width: 1px;border-color: #EFEFF4" type="textarea" :autosize="{minRows: 1}" :placeholder="$t('invoiceCreate.placeholderInputComment')" v-model="comment"></el-input>
                        </div>

                    </el-tab-pane>


                    <el-tab-pane :label="$t('invoiceCreate.tabPreview')">
                        <!--https://juejin.im/post/5cd9498651882515cc7e465c pdf.js 打包-->
                        <!--:src="https://swiftinvoicewebsite.s3-us-west-2.amazonaws.com/tewee3.pdf"-->
                        <!--<img src="@/static/invoice_logo_new.png"  alt="" @load="loadimgage">-->

                        <iframe @load="loadINGPDF"
                                :src="pdfPreviewUrl"
                                frameborder="0" width="100%"
                                class="pdf-window">
                        </iframe>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('invoiceCreate.tabSendEmail')">
                        <div class="invoice-send-email-panel">
                            <div class="invoice-email-field invoice-email-to-field">
                                <label>{{$t('invoiceCreate.labelTo')}}</label>
                                <div class="invoice-recipient-line">
                                    <el-input class="invoice-email-line-input" type="text" :placeholder="$t('invoiceCreate.placeholderAddRecipient')" v-model="clientInfo.clientEmail"></el-input>
                                </div>
                            </div>
                            <div class="invoice-email-field">
                                <label>{{$t('invoiceCreate.cc')}}</label>
                                <el-input class="invoice-email-line-input" type="text" :placeholder="$t('invoiceCreate.cc')" v-model="sendEmail.ccEmail"></el-input>
                            </div>
                            <div class="invoice-email-field">
                                <label>{{$t('invoiceCreate.bcc')}}</label>
                                <el-input class="invoice-email-line-input" type="text" :placeholder="$t('invoiceCreate.bcc')" v-model="sendEmail.bccEmail"></el-input>
                            </div>
                            <div class="invoice-email-field">
                                <label>{{$t('invoiceCreate.labelSubject')}}</label>
                                <el-input class="invoice-email-line-input" type="text" :placeholder="$t('invoiceCreate.placeholderEmailSubject')" v-model="sendEmail.subject"></el-input>
                            </div>
                            <el-input class="invoice-email-message" type="textarea" :autosize="{minRows: 8}" :placeholder="$t('invoiceCreate.placeholderMessage')" v-model="userSetting.emailMessage"></el-input>
                            <div class="invoice-email-attachments">
                                <h2>{{$t('invoiceCreate.sectionAttachments')}} <span>(1)</span></h2>
                                <div class="invoice-email-attachment-row">
                                    <div class="invoice-email-pdf-icon"><span>{{$t('invoiceCreate.pdf')}}</span></div>
                                    <div class="invoice-email-attachment-info">
                                        <strong>{{documentName}}-{{numPrefix}}{{invoiceMaxNumber}}.pdf</strong>
                                        <span>{{$t('invoiceCreate.pdf')}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="invoice-email-footer">
                                <el-button class="invoice-send-email-button" @click.native.prevent="createInvoice"
                                           :disabled="saveRequestPending" :loading="saveRequestPending">
                                    <i class="el-icon-position"></i>
                                    <span>{{$t('common.sendEmail')}}</span>
                                </el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <div class="invoice-side-panel" style="margin-left: 3%;width: 45%;">
                    <h1 style="margin-bottom: 0px;">
                        {{documentName}}
                    </h1>


                    <div v-if="jobDetailsListList.length > 0" class="summary-job-details-row">
                        <el-button class="summary-job-details-button" :disabled=rightCantEdit @click="jobDetailsDialogStatus=true">{{$t('invoiceCreate.dialogJobDetails')}}</el-button>
                    </div>

                    <div class="column">
                        <span>#</span>
                        <el-col :span="12">
                            <div class="text_align_right" style="display: flex;">
                                <el-input type="text" style="margin-right: 5px" :disabled=rightCantEdit
                                          :placeholder="documentPrefixPlaceholder" v-model="numPrefix"></el-input>
                                <el-input type="text" :disabled=rightCantEdit placeholder=""
                                          v-model="invoiceMaxNumber"></el-input>
                            </div>
                        </el-col>
                    </div>
                    <div class="box">
                        <div class="column">
                            <span class="item">{{userSetting.dateLabel}}</span>
                            <el-col :span="12">
                                <el-date-picker popper-class="invoice-editor-lighter" :disabled=rightCantEdit class="text_align_right" :editable=false
                                                align="right"
                                                type="date"
                                                format="MMM dd, yyyy" v-model="invoiceStartDate" :clearable=false
                                                style="width: 100%;"></el-date-picker>
                            </el-col>
                        </div>

                        <div class="column">
                            <span>{{$t('invoiceCreate.labelStatus')}}</span>
                            <el-col :span="12">
                                <el-select popper-class="invoice-editor-lighter" :disabled=rightCantEdit class="text_align_right select_padding" v-model="estimateStatus" placeholder="">
                                    <el-option
                                            v-for="item in termOptionList" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </div>

                        <!--<div class="column">
                            <span>Due Date</span>
                            <el-col :span="12">
                                <el-date-picker popper-class="invoice-editor-lighter" :disabled=rightCantEdit class="text_align_right" type="date"
                                                format="MMM dd, yyyy"
                                                :editable=false v-model="dueDate" :clearable=false
                                                :picker-options="pickerBeginDateAfter"
                                                style="width: 100%;"></el-date-picker>
                            </el-col>
                        </div>-->


                        <el-divider class="invoice-summary-spacer"></el-divider>
                        <div class="column span_margin_button">
                            <span>{{userSetting.subtotalLabel}}</span>
                            <span>{{ xiaoshudianfenge1(computeSubTotal,userSetting)}}</span>
                        </div>

                        <div v-if="!isPurchaseOrder" class="column span_margin_button">
                            <span>{{$t('common.discount')}}</span>
                            <el-radio-group :disabled=rightCantEdit v-model="bigDiscountType" size="mini">
                                <el-radio-button label="0">$</el-radio-button>
                                <el-radio-button label="1">%</el-radio-button>
                            </el-radio-group>
                            <el-col :span="12">
                                <div class="text_align_right">
                                    <el-input @keyup.native="formatUnsignedAmountNow1" @blur="formatBigDiscount()"
                                              :disabled=rightCantEdit onfocus="this.select()"
                                              v-model="bigDiscount"></el-input>
                                </div>
                            </el-col>
                        </div>
                        <el-divider class="invoice-summary-spacer" v-if="totalInvoiceTaxInfoMap.size > 0"></el-divider>

                        <!-- <div class="span_margin_button" v-if="userSetting.withHoldingActive === 1">
                             <span>{{userSetting.withHoldingTaxName}}</span>
                         </div>-->

                        <!--<div class="column span_margin_button" style="margin-bottom: 30px"
                             v-if="userSetting.withHoldingActive === 1">
                            <span>{{parseFloat((userSetting.withHoldingTaxRate*100.0).toFixed(6))+"%"}} of {{xiaoshudianfenge1(totalWithholdingMoney.totalOriginItemPrice,userSetting)}}</span>
                            <span>{{xiaoshudianfenge1(totalWithholdingMoney.money,userSetting)}}</span>
                        </div>-->


                        <!-- taxItem  =====[ "two&&0.3&&0", [ 0.6, 2 ] ]-->
                        <div v-for="taxItem in totalInvoiceTaxInfoMap" :key="taxItem[0]" class="column"
                             style="align-items: flex-end;">
                            <div class="span_margin_button" style="margin-bottom: 15px">
                                <span>{{taxItem[0].split('&&')[0]}}</span>
                                <span v-if="taxItem[0].split('&&')[2] === '0'">{{$t('common.excl')}}</span>
                                <span v-else-if="taxItem[0].split('&&')[2] === '1'">{{$t('common.incl')}}</span>
                                <br><br>
                                <span style="margin-top: 10px">{{parseFloat((taxItem[0].split('&&')[1]*100).toFixed(4))+'%'}} {{$t('common.of')}} {{ xiaoshudianfenge1(taxItem[1][1],userSetting)}}</span>
                            </div>
                            <div class="span_margin_button" style="margin-bottom: 15px">
                                <span>{{xiaoshudianfenge1(taxItem[1][0],userSetting)}}</span>
                            </div>
                        </div>
                        <el-divider class="invoice-summary-spacer"></el-divider>

                        <template v-if="!isPurchaseOrder">
                            <div class="column" v-if="userSetting.isShowShippingField === 1">
                                <span>{{$t('common.shipping')}}({{userSetting.currency}})</span>
                                <el-col :span="12">
                                    <div class="text_align_right">
                                        <el-input :disabled=rightCantEdit type="number"
                                                  @click.native.prevent="shippingDialogStatus = true"
                                                  :editable=false v-model="shipping.amount"></el-input>
                                    </div>
                                </el-col>
                            </div>

                            <el-dialog :title="$t('invoiceCreate.dialogShippingInfo')" :visible.sync="shippingDialogStatus" width="30%">
                                <el-form label-position="left" label-width="140px">
                                    <el-form-item :label="$t('invoiceCreate.labelAmount')+'('+userSetting.currency+')'">
                                        <el-input v-model="shipping.amount" onfocus="this.select()"
                                                  @keyup.native="formatUnsignedAmountNow1" @blur="formatShippingAmount()"
                                                  autocomplete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelShipDate')">
                                        <el-date-picker popper-class="invoice-editor-lighter" :editable=false type="date" format="MMM dd,yyyy"
                                                        v-model="shipping.shipDate" :clearable=false
                                                        style="width: 100%;"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelShipVia')">
                                        <el-input v-model="shipping.shipVia" autocomplete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelTrackingNumber')">
                                        <el-input v-model="shipping.shippingTracking" autocomplete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('invoiceCreate.labelFob')">
                                        <el-input v-model="shipping.fob" autocomplete="off"></el-input>
                                    </el-form-item>

                                </el-form>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="shippingDialogStatus = false">{{$t('common.cancel')}}</el-button>
                                    <el-button type="primary" @click="shippingDialogStatus = false">{{$t('common.save')}}</el-button>
                                </div>
                            </el-dialog>
                        </template>


                        <div class="column span_margin_button">
                            <span>{{userSetting.totalLabel}}</span>
                            <span>{{ xiaoshudianfenge1(totalMarks,userSetting)}}</span>
                        </div>

                        <!--<div class="column span_margin_button">
                            <span>Paid</span>
                            <span>{{xiaoshudianfenge1(paid,userSetting)}}</span>
                        </div>

                        <div class="column">
                            <span>Balance Due</span>
                            <span>{{xiaoshudianfenge1(computeBalanceDueMoney,userSetting)}}</span>
                        </div>-->
                        <!----------------------------------弹出框,付款---------------------------------->

                        <!----------------------------------弹出框,付款---------------------------------->
                    </div>
                    <!--<el-divider></el-divider>
                    <el-button type="text" v-if="!AddPaymentCantEdit" @click="openAddPaymentDialog()">Add payment
                    </el-button>-->

                    <!--<div>
                        <el-table :data="paymentHistory">
                            <el-table-column prop="paidDate" label="Date" :formatter="dateFormat">
                            </el-table-column>
                            <el-table-column prop="paidType" label="Type">
                            </el-table-column>
                            <el-table-column prop="paidMoney" :formatter="formatPaidShowMoney" label="Total">
                            </el-table-column>
                            <el-table-column fixed="right" label="" width="">
                                <template slot-scope="scope">
                                    <el-button type="text" style="color: red;font-size: 15px" size="small"
                                               :disabled=rightCantEdit
                                               @click="deletePayment(scope.row)">del
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>-->

                    <!--<el-dialog title="Add payment" :visible.sync="addPaymentDialog" width="40%">
                        <el-form label-width="200px">
                            <el-switch @change="changeFullPayStatusEvent"
                                       v-model="paymentObj.fullPayStatus"
                                       active-color="#13ce66"
                                       active-text="Mark as fully paid"
                                       inactive-color="#ff4949">
                            </el-switch>

                            <el-form-item :label="'Amount('+userSetting.currency+')'">
                                <el-input v-model="paymentObj.paidMoney" :autofocus="payMentAutofocus"
                                          @keyup.native="formatUnsignedAmountNow1" @blur="formatPaymentMoney()"
                                          onfocus="this.select()"></el-input>
                            </el-form-item>
                            <el-form-item label="Method">
                                <el-input v-model="paymentObj.paidType"></el-input>
                            </el-form-item>
                            <el-form-item label="Date">
                                <el-date-picker popper-class="invoice-editor-lighter" :editable=false type="date" format="MMM dd,yyyy"
                                                v-model="paymentObj.paidDate" :clearable=false
                                                style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-form>
                        &lt;!&ndash;弹框的底部标签&ndash;&gt;
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="addPaymentDialog = false">close</el-button>
                            <el-button type="primary" @click="savePayment()">Add payment
                            </el-button>
                        </div>
                    </el-dialog>-->


                    <el-dialog :title="$t('invoiceCreate.dialogJobDetails')" :visible.sync="jobDetailsDialogStatus" width="40%">
                        <el-form label-position="right" label-width="120px">
                            <el-form-item v-for="(value,index) in jobDetailsListList" :key="index" :label="value.fieldKey">
                                <el-input type="text" v-model="value.fieldValue"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="jobDetailsDialogStatus = false">{{$t('common.close')}}</el-button>
                            <el-button type="primary" @click="jobDetailsDialogStatus = false">{{$t('common.save')}}</el-button>
                        </div>
                    </el-dialog>



                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {uuid, timest, toTmpDateWithCurrentTime, toTmpTime, validateEmail} from '@/utils/validate'
    import {formatEnglishDate} from '@/utils/time'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {formatSignedRateAtCreate, formatSignedRateNow, formatUnsignedAmountAtCreate, formatUnsignedAmountNow, formatUnsignedPercentageAtCreate} from '@/utils/numberFormat'
    import {buildInvoiceImageForRequest} from '@/utils/invoiceImage'
    import {discardPreparedFileUpload, duplicateInvoiceImageFile, getDownloadV2Url, getFileUploadUrl, getUploadRemoteKey, INVOICE_IMAGES_FOLDER, prepareFileUpload, takeUploadInnerUUID} from '@/utils/fileUpload'
    import {syncCompanySelection} from '@/utils/company'
    import {buildTaxCalculationFactorMap, createInvoiceTaxInfoList} from '@/utils/invoiceTax'
    import {clientDefaultDiscountForItem, storedDiscountForEditor} from '@/utils/clientDiscount'
    import {searchDocumentClients, searchDocumentItems} from '@/utils/documentCatalogSearch'
    import {createEmptyDocumentClient} from '@/utils/documentClient'
    import {isValidItemDecimal} from '@/utils/itemInputValidation'
    import {limitServerNumber, ServerNumberRangeError} from '@/utils/serverNumberLimit'
    import {serializeDocumentEditorState} from '@/utils/documentEditorState'
    import {parseJobDetails, serializeJobDetails} from '@/utils/documentTextValidation'
    import {reportHandledError} from '@/utils/sentry'
    import moment from 'moment-timezone'

    export default {
        data() {
            return {
                clientInfo: {
                    pageHaveChange: 0,
                    name: '',
                    clientEmail: '',
                    phone: '',
                    cell: '',
                    contact: '',
                    fax: '',
                    pager: '',
                    website: '',
                    billingAddressLine1: '',
                    billingAddressLine2: '',
                    billingAddressLine3: '',
                    shippingName: '',
                    shippingAddressLine1: '',
                    shippingAddressLine2: '',
                    shippingAddressLine3: '',
                    itemDiscount: 0,
                    itemDiscountAsPercent: 0,
                    note: '',
                    innerUUID: ""
                },
                fileList: [],
                paymentHistory: [],
                originPaymentHistory: [],
                clientDialogStatus: false,
                clientDialogSnapshot: null,
                clientDialogPreviousStatus: 0,
                termOptionList: [
                    {value: 'Issued', label: this.$t('invoiceCreate.statusIssued')},
                    {value: 'Approved', label: this.$t('invoiceCreate.statusApproved')},
                    {value: 'Pending', label: this.$t('invoiceCreate.statusPending')},
                    {value: 'Withdrawn', label: this.$t('invoiceCreate.statusWithdrawn')}
                ],
                comment: '',
                estimateStatus: "Issued",
                // 0:金额,1.税率
                bigDiscountType: "0",
                bigDiscount: 0,
                createClientDivStatus: 0,
                invoiceStartDate: new Date(),
                dueDate: new Date(),
                itemList: [],
                paid: 0,
                taxInfoList: [],
                clientSearchRequestSequence: 0,
                itemSearchRequestSequence: 0,
                //所有税计算之后用于展示的税费用，涉及到的各种税的税率都要展示
                totalInvoiceTaxInfoMap: new Map(),
                userSetting: {},
                totalWithholdingMoney: {},
                // addPaymentDialog: false,
                /*paymentObj: {
                    paidMoney: 0,
                    paidDate: new Date(),
                    truePaidMoney: 0,
                    isFullPay: 0,
                    paidType: "",
                    note: ""
                },*/
                sendEmail: {
                    toEmail: "",
                    ccEmail: "",
                    bccEmail: "",
                    subject: "",
                    comment: ""
                },
                pickerBeginDateAfter: {
                    disabledDate: time => {
                        let beginDateVal = this.invoiceStartDate;
                        if (beginDateVal) {
                            return time.getTime() < new Date(new Date(beginDateVal.setHours(0, 0, 0, 0)));
                        }
                    }
                },
                shippingDialogStatus: false,
                shipping: {
                    amount: 0,
                    shipDate: new Date(),
                    shipVia: "",
                    shippingTracking: "",
                    fob: ""
                },
                invoiceMoneyInfo: {
                    allExclusiveTaxMoney: 0,
                    allInclusiveTaxMoney: 0,
                    allTaxMoney: 0,
                },
                taxInfoUUIDArrayKey: "",
                invoiceMaxNumber: "",
                numPrefix: "",
                attachPhotosStatus: false,
                pdfPreviewUrl: "",
                invoiceUUID: "",
                companyUUID: "",
                companyName: "",
                tabIndex: '0',
                requestURL: "",
                loginLoading: false,
                initialDataLoaded: false,
                loadError: '',
                saveRequestPending: false,
                rightCantEdit: false,
                // AddPaymentCantEdit: false,
                uploadData: {
                    email: ""
                },
                uploadFileMap: {},
                // payMentAutofocus: false,
                saveNewItemToItem: 1,
                buttonDisabledStatus: false,
                pdfLoadingStatus: true,
                pdfLodingIndex: 0,
                jobDetailsDialogStatus: false,
                jobDetailsListList: [],
                emailed: 0,
                documentInitialState: ''
            };
        },
        methods: {
            loadINGPDF() {
                if (this.pdfLodingIndex != 0) {
                    //页面第一次加载不做此操作,因为页面加载也会调用这个方法,会影响到真正有作用的地方
                    this.loginLoading = false;
                }
                this.pdfLodingIndex = this.pdfLodingIndex + 1;
            },
            xiaoshudianfenge1(value, setting) {
                try {
                    limitServerNumber(value);
                    return xiaoshudianfenge(value, setting);
                } catch (error) {
                    if (error instanceof ServerNumberRangeError) {
                        return this.$t('invoiceCreate.calculatedAmountOutOfRange');
                    }
                    throw error;
                }
            },
            formatUnsignedAmountNow1: formatUnsignedAmountNow,
            formatSignedRateNow1: formatSignedRateNow,
            goBack() {
                let self = this;
                self.$router.push(this.documentListRoute);
            },
            queryCompanyInfo() {
                this.loginLoading = true;
                this.initialDataLoaded = false;
                this.loadError = '';
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.applyLoadedCompanyData(selectedData);
                    this.queryTaxInfoList();
                }).catch(() => {
                    this.loginLoading = false;
                    this.initialDataLoaded = false;
                    this.loadError = this.$t('invoiceCreate.initialDataLoadFailed');
                });
            },
            applyLoadedCompanyData(selectedData) {
                this.userSetting = selectedData.setting;
                this.companyUUID = selectedData.company.innerUUID;
                this.userSetting.withHoldingActive = 0;
                if (this.invoiceType === 2) {
                    this.invoiceMaxNumber = selectedData.company.nextNewPurchaseOrderNumber;
                    this.numPrefix = selectedData.company.purchaseOrderNumbering;
                } else if (this.invoiceType === 3) {
                    this.invoiceMaxNumber = selectedData.company.nextNewCreditMemoNumber;
                    this.numPrefix = selectedData.company.creditMemoNumbering;
                } else {
                    this.invoiceMaxNumber = selectedData.company.nextNewEstimateNumber;
                    this.numPrefix = selectedData.company.estimateNumbering;
                }
                this.companyName = selectedData.company.companyName;
                this.sendEmail.bccEmail = selectedData.setting.emailBcc;
                this.sendEmail.ccEmail = selectedData.setting.emailCc;
                if (this.invoiceType === 2) {
                    this.comment = selectedData.setting.purchaseOrderComment;
                } else if (this.invoiceType === 3) {
                    this.comment = selectedData.setting.creditMemoComment;
                } else {
                    this.comment = selectedData.setting.estimateComment;
                }
                this.jobDetailsListList = parseJobDetails(selectedData.company.jobDetails);
            },
            queryTaxInfoList() {
                this.loginLoading = true;
                let that = this;
                this.$axios.post('query_tax_info_list_user_web', {
                    params: {
                        "currentPage": 1,
                        "pageSize": 99999,
                        "delStatus": 0,
                        "invoiceTaxOrNot": 1,
                        "createInvoice": 1,
                        "createType": this.invoiceType,
                        "companyUUID": this.companyUUID
                    }
                }).then(async response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error(response.data.errorMsg);
                    }
                    let tempTaxInfoList = createInvoiceTaxInfoList(
                        response.data.dataList,
                        () => uuid(null, 37)
                    );
                    that.taxInfoList = tempTaxInfoList;
                    this.documentInitialState = serializeDocumentEditorState(this);

                    this.$watch('itemList', function () {
                        this.pageHaveChange = 1;
                    }, {deep: true});

                    this.$watch('clientInfo', function () {
                        this.pageHaveChange = 1;
                    }, {deep: true});

                    // Check for copy source data (from Copy action on list page)
                    const copySourceRaw = localStorage.getItem('copySourceData');
                    if (copySourceRaw) {
                        await that.applyCopySource(JSON.parse(copySourceRaw));
                        localStorage.removeItem('copySourceData');
                    }
                    this.loginLoading = false;
                    this.initialDataLoaded = true;
                }).catch(function () {
                    that.loginLoading = false;
                    that.initialDataLoaded = false;
                    that.loadError = that.$t('invoiceCreate.initialDataLoadFailed');
                })
            },
            async applyCopySource(sourceData) {
                const detail = sourceData.detail;
                const options = sourceData.options;
                const sourceInvoice = detail.invoice;

                // Pre-fill client info
                if (options.copyClient && detail.userClient != null) {
                    const c = detail.userClient;
                    this.clientInfo.name = c.name || '';
                    this.clientInfo.clientEmail = c.clientEmail || '';
                    this.clientInfo.phone = c.phone || '';
                    this.clientInfo.cell = c.cell;
                    this.clientInfo.contact = c.contact;
                    this.clientInfo.fax = c.fax;
                    this.clientInfo.pager = c.pager;
                    this.clientInfo.website = c.website;
                    this.clientInfo.billingAddressLine1 = c.billingAddressLine1 || '';
                    this.clientInfo.billingAddressLine2 = c.billingAddressLine2 || '';
                    this.clientInfo.billingAddressLine3 = c.billingAddressLine3 || '';
                    this.clientInfo.shippingName = c.shippingName || '';
                    this.clientInfo.shippingAddressLine1 = c.shippingAddressLine1 || '';
                    this.clientInfo.shippingAddressLine2 = c.shippingAddressLine2 || '';
                    this.clientInfo.shippingAddressLine3 = c.shippingAddressLine3 || '';
                    this.clientInfo.note = c.note || '';
                    this.clientInfo.itemDiscount = c.itemDiscount;
                    this.clientInfo.itemDiscountAsPercent = c.itemDiscountAsPercent;
                    this.clientInfo.innerUUID = c.innerUUID || '';
                    this.clientInfo.pageHaveChange = 1;
                    this.createClientDivStatus = 1;
                }

                // Pre-fill items
                if (options.copyItems && detail.itemList != null) {
                    this.itemList = [];
                    for (let i = 0; i < detail.itemList.length; i++) {
                        const srcItem = detail.itemList[i];
                        if (srcItem.syncStatus === 1) continue;

                        let item = {};
                        item.itemDescription = srcItem.itemDescription || '';
                        item.quantity = srcItem.quantity || 0;
                        item.rate = srcItem.rate || 0;
                        item.itemCode = srcItem.itemCode || '';
                        item.everyItemDiscountType = srcItem.discountAsPercent != null ? srcItem.discountAsPercent : 0;
                        item.everyItemDiscount = storedDiscountForEditor(
                            srcItem.discount != null ? srcItem.discount : 0,
                            item.everyItemDiscountType
                        );
                        if (this.isPurchaseOrder) {
                            item.everyItemDiscountType = 0;
                            item.everyItemDiscount = 0;
                        }
                        item.type = 0;
                        item.withholdingMoney = 0;
                        item.syncStatus = 0;
                        item.innerUUID = uuid(null, 37);
                        item.parentUUID = srcItem.parentUUID;
                        item.isShowInventory = srcItem.isShowInventory || 0;
                        item.inventoryNumber = srcItem.inventoryNumber;
                        item.isShowCost = srcItem.isShowCost;
                        item.cost = srcItem.cost;
                        item.unit = srcItem.unit;
                        item.createdFromTime = 0;
                        item.timeUUID = "";

                        // Estimates/POs don't use withholding (withHoldingActive is forced to 0 in mounted)
                        item.everyItemWithholdingStatus = 0;

                        // Build everyTaxInfoList from master taxInfoList
                        item.everyTaxInfoList = JSON.parse(JSON.stringify(this.taxInfoList));
                        for (let j = 0; j < item.everyTaxInfoList.length; j++) {
                            item.everyTaxInfoList[j].haveRateList = String(item.everyTaxInfoList[j].rates == null
                                ? '' : item.everyTaxInfoList[j].rates).split('&&').filter(rate => rate !== '');
                            for (let k = 0; k < item.everyTaxInfoList[j].haveRateList.length; k++) {
                                item.everyTaxInfoList[j].haveRateList[k] = parseFloat((item.everyTaxInfoList[j].haveRateList[k] * 1).toFixed(8));
                            }
                            item.everyTaxInfoList[j].chooseRate = item.everyTaxInfoList[j].haveRateList[0];
                        }

                        // Match the source invoice tax to the current setting tax before assigning its rate.
                        if (srcItem.taxRateInfo && srcItem.taxRateInfo.length > 0) {
                            let taxRateInfoArray = String(srcItem.taxRateInfo == null ? '' : srcItem.taxRateInfo).split("&&");
                            for (let j = 0; j < taxRateInfoArray.length; j++) {
                                let parts = taxRateInfoArray[j].split(":");
                                let taxUUID = parts[0];
                                let taxRate = parseFloat(parts[1]);
                                let sourceTax = detail.taxInfoList.find(taxInfo => taxInfo.innerUUID === taxUUID);
                                if (sourceTax === undefined) {
                                    continue;
                                }
                                let targetTax = item.everyTaxInfoList.find(taxInfo => taxInfo.innerUUID === sourceTax.settingTaxInfoUUID);
                                if (targetTax === undefined) {
                                    continue;
                                }
                                targetTax.chooseRate = taxRate === -1 ? "-1" : taxRate;
                            }
                        }

                        this.itemList.push(item);
                    }
                }

                // Pre-fill attachments
                if (options.copyAttachments && detail.invoiceImageList != null) {
                    this.fileList = [];
                    for (let i = 0; i < detail.invoiceImageList.length; i++) {
                        const srcFile = detail.invoiceImageList[i];
                        if (srcFile.syncStatus === 1) continue;
                        let copiedFile;
                        try {
                            copiedFile = await duplicateInvoiceImageFile(this.$store.state.requestURL, srcFile);
                        } catch (error) {
                            this.reportUploadError(error, {name: srcFile.imagePath, size: 0}, 'estimate_image_copy_upload');
                            continue;
                        }
                        let fileInfo = {
                            name: copiedFile.innerUUID,
                            url: copiedFile.url,
                            innerUUID: copiedFile.innerUUID,
                            remoteKey: copiedFile.remoteKey,
                            attachmentName: srcFile.title,
                            attachmentDesciption: srcFile.detail,
                            syncStatus: 0
                        };
                        this.fileList.push(fileInfo);
                    }
                }

                // Pre-fill estimate-level fields from source
                if (sourceInvoice.comment != null) {
                    this.comment = sourceInvoice.comment;
                }
                if (sourceInvoice.discountAsPercent != null && !this.isPurchaseOrder) {
                    this.bigDiscountType = sourceInvoice.discountAsPercent + "";
                }
                if (sourceInvoice.discount != null && !this.isPurchaseOrder) {
                    this.bigDiscount = storedDiscountForEditor(sourceInvoice.discount, Number(this.bigDiscountType));
                }
                this.estimateStatus = "Issued";

                // Pre-fill shipping info (only for estimates, not POs)
                if (!this.isPurchaseOrder) {
                    if (sourceInvoice.shipping != null) {
                        this.shipping.amount = sourceInvoice.shipping;
                    }
                    const shippingDateSeconds = Number(sourceInvoice.shippingDate == null ? 0 : sourceInvoice.shippingDate);
                    if (shippingDateSeconds > 0) {
                        this.shipping.shipDate = new Date(shippingDateSeconds * 1000);
                    }
                    if (sourceInvoice.shippingVia != null) {
                        this.shipping.shipVia = sourceInvoice.shippingVia;
                    }
                    if (sourceInvoice.shippingTracking != null) {
                        this.shipping.shippingTracking = sourceInvoice.shippingTracking;
                    }
                    if (sourceInvoice.shippingFOB != null) {
                        this.shipping.fob = sourceInvoice.shippingFOB;
                    }
                }

                // Date is already set to today by default (new Date() in data())
                // invoiceMaxNumber and numPrefix are set from query_setting_and_company
                // Do NOT override these - the new document should get a fresh number

                // Set pageHaveChange to 1 so the form reflects that it has unsaved data
                this.pageHaveChange = 1;
            },
            formatItemCountNumberBlur(index, itemList) {
                itemList[index].quantity = formatUnsignedAmountAtCreate(itemList[index].quantity);
            },
            formatBigDiscount() {
                this.bigDiscount = this.bigDiscountType === "1"
                    ? formatUnsignedPercentageAtCreate(this.bigDiscount)
                    : formatUnsignedAmountAtCreate(this.bigDiscount);
            },

            formatPaymentMoney() {
                this.paymentObj.paidMoney = formatUnsignedAmountAtCreate(this.paymentObj.paidMoney);
            },

            formatShippingAmount() {
                this.shipping.amount = formatUnsignedAmountAtCreate(this.shipping.amount);
            },

            formatItemRateNumberBlur(index, itemList) {
                itemList[index].rate = formatSignedRateAtCreate(itemList[index].rate);
            },

            formatEveryItemDiscount(index, itemList) {
                itemList[index].everyItemDiscount = itemList[index].everyItemDiscountType === "1"
                    || itemList[index].everyItemDiscountType === 1
                    ? formatUnsignedPercentageAtCreate(itemList[index].everyItemDiscount)
                    : formatUnsignedAmountAtCreate(itemList[index].everyItemDiscount);
            },

            ///////////////上传///////////////
            handleRemove(fileName) {
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].innerUUID === fileName) {
                        this.fileList[i].syncStatus = 1;
                        // this.fileList.splice(i, 1);
                    }
                }
            },
            onBeforeUpload(file) {
                /*let isLt1M = file.size / 1024 / 1024 < 0.001;
                if (!isLt1M) {
                    this.$message.error('');
                }
                return isLt1M;*/
                prepareFileUpload(this.uploadData, this.uploadFileMap, file, INVOICE_IMAGES_FOLDER);
                this.attachPhotosStatus = true;
            },
            handlePictureCardPreview() {

            },
            formatPaidShowMoney: function (row, column) {
                var money = row[column.property];
                if (money == undefined) {
                    return "";
                }
                return this.xiaoshudianfenge1(money, this.userSetting);
            },
            reportUploadError(error, file, operation) {
                reportHandledError(error, {
                    level: 'error',
                    module: 'file_upload',
                    operation: operation,
                    tags: {
                        file_type: 'estimate_image'
                    },
                    context: {
                        fileName: file == null ? '' : file.name,
                        fileSize: file == null ? 0 : file.size,
                        folderName: INVOICE_IMAGES_FOLDER
                    }
                });
            },
            showUploadError(error, file, operation) {
                discardPreparedFileUpload(this.uploadFileMap, file);
                this.attachPhotosStatus = false;
                this.reportUploadError(error, file, operation);
                this.$message({
                    type: 'error',
                    message: this.$t('common.uploadFailed'),
                    duration: 6000
                });
            },
            handleUploadError(error, file) {
                this.showUploadError(error, file, 'estimate_image_upload_request');
            },
            handleSuccess(res, file) {
                this.attachPhotosStatus = false;
                if (res == null || Number(res.errorCode) !== 0) {
                    this.showUploadError(new Error(res == null || res.errorMsg == null ? 'estimate image upload failed' : res.errorMsg), file, 'estimate_image_upload_response');
                    return;
                }
                let fileList = res.uploadFileList || [];
                if (fileList.length === 0) {
                    this.showUploadError(new Error('estimate image uploadFileList is empty'), file, 'estimate_image_upload_response');
                    return;
                }
                if (Number(res.errorCode) === 0) {
                    const innerUUID = takeUploadInnerUUID(this.uploadFileMap, file);
                    const remoteKey = getUploadRemoteKey(INVOICE_IMAGES_FOLDER, innerUUID);
                    for (let i = 0; i < fileList.length; i++) {
                        let fileInfo = {
                            name: innerUUID,
                            url: getDownloadV2Url(this.$store.state.requestURL, remoteKey),
                            innerUUID: innerUUID,
                            remoteKey: remoteKey,
                            attachmentName: this.$t('common.attachment') + ' #' + (this.fileList.length + 1),
                            syncStatus: 0
                        };
                        this.fileList.push(fileInfo);
                    }
                    this.$message({
                        type: 'info',
                        message: this.$t('common.uploadSuccess'),
                        duration: 6000
                    });
                }
            },
            ///////////////上传///////////////
            clickTab(tab) {
                this.tabIndex = tab.index;

                if (tab.index === "0") {
                    // 创建
                    this.rightCantEdit = false;
                    // this.AddPaymentCantEdit = false;
                    this.buttonDisabledStatus = false;
                }
                if (tab.index === "1") {
                    //预览
                    this.createInvoice(tab.index);
                    this.rightCantEdit = true;
                    // this.AddPaymentCantEdit = true;
                    this.buttonDisabledStatus = true;
                }
                if (tab.index === "2") {
                    //发送邮件
                    this.sendEmail.subject = this.documentName + "-" + this.numPrefix + this.invoiceMaxNumber + ".pdf from " + this.companyName;
                    this.rightCantEdit = true;
                    // this.AddPaymentCantEdit = true;
                    this.buttonDisabledStatus = false;
                }
            },

            openAddItemDiarg() {
                var item = {};
                item.itemDescription = "";
                item.quantity = 0;
                item.rate = 0;
                item.everyItemTaxCheckList = [];
                const defaultDiscount = this.isPurchaseOrder
                    ? {type: 0, value: 0}
                    : clientDefaultDiscountForItem(this.clientInfo);
                item.everyItemDiscountType = defaultDiscount.type;
                item.everyItemDiscount = defaultDiscount.value;
                item.itemCode = "";
                item.type = 0;
                item.withholdingMoney = 0.0;
                item.syncStatus = 0;
                item.parentUUID = "";
                item.isShowInventory = 0;
                item.inventoryNumber = 0;
                item.isShowCost = 0;
                item.cost = 0;
                item.unit = "";
                item.createdFromTime = 0;
                item.timeUUID = "";

                if (this.userSetting.withHoldingActive == 1) {
                    item.everyItemWithholdingStatus = 1;
                }

                item.everyTaxInfoList = JSON.parse(JSON.stringify(this.taxInfoList));
                for (let i = 0; i < item.everyTaxInfoList.length; i++) {
                    item.everyTaxInfoList[i].haveRateList = String(item.everyTaxInfoList[i].rates == null
                        ? '' : item.everyTaxInfoList[i].rates).split('&&').filter(rate => rate !== '');
                    //确保小数点精度
                    for (let j = 0; j < item.everyTaxInfoList[i].haveRateList.length; j++) {
                        item.everyTaxInfoList[i].haveRateList[j] = parseFloat((item.everyTaxInfoList[i].haveRateList[j] * 1).toFixed(8))
                    }
                    item.everyTaxInfoList[i].chooseRate = item.everyTaxInfoList[i].haveRateList[0];
                }
                // 用于判断是否创建过,保证uuid不会重新创建
                this.itemList.push(item);
            },
            deleteItem(index, item) {
                item.syncStatus = 1;
                // this.itemList.splice(index, 1);
            },
            //时间格式化
            dateFormat: function (row, column) {
                var timestamp = row[column.property] * 1000;
                if (timestamp == undefined) {
                    return "";
                }
                return formatEnglishDate(timestamp);
            },
            /*deletePayment(row) {
                let index = 0;
                for (let i = 0; i < this.originPaymentHistory.length; i++) {
                    let tempPayment = this.originPaymentHistory[i];
                    if (tempPayment.innerUUID == row.innerUUID) {
                        index = i;
                        this.originPaymentHistory[i].syncStatus = 1;
                        this.originPaymentHistory[i].accessDate = timest();
                        this.originPaymentHistory[i].updateTime = timest();
                    }
                }
                this.paid = this.paid - this.originPaymentHistory[index].paidMoney;
                this.paymentHistory.splice(index, 1);
            },
            savePayment() {

                if (this.paymentObj.paidMoney <= 0) {
                    this.$message.error('The amount must be greater than zero');
                    return;
                }

                let paidMoney = 0;
                if (this.paymentObj.isFullPay == 1) {
                    paidMoney = this.paymentObj.truePaidMoney;
                } else {
                    paidMoney = this.paymentObj.paidMoney;
                }

                let tempObj = {
                    innerUUID: uuid(null, 37),
                    paidMoney: paidMoney,
                    paidType: this.paymentObj.paidType,
                    createDate: timest(),
                    paidDate: toTmpTime(this.paymentObj.paidDate),
                    syncStatus: 0,
                    accessDate: timest(),
                    updateTime: timest(),
                    fromClient: 3
                };
                this.paymentHistory.push(tempObj);
                this.originPaymentHistory.push(tempObj);
                this.paid = this.paid + parseFloat(tempObj.paidMoney);
                this.paymentObj = {
                    paidMoney: 0,
                    paidDate: new Date(),
                    isFullPay: 0,
                    truePaidMoney: 0,
                    paidType: "",
                    note: ""
                };
                this.addPaymentDialog = false;
            },*/


            addCreateInvoiceItem: function (item, i, belongToInvoiceTag) {

                if (belongToInvoiceTag == 1) {

                    let everyItemWithholdingMoney = 0;
                    let everyItemWithholdingStatus = 0;
                    if (!this.isPurchaseOrder) {
                        if (null != item.everyItemWithholdingMoney) {
                            everyItemWithholdingMoney = item.everyItemWithholdingMoney;
                        }
                        if (null != item.everyItemWithholdingStatus) {
                            everyItemWithholdingStatus = item.everyItemWithholdingStatus;
                        }
                    }

                    let everyItemDiscount = 0;
                    let everyItemDiscountType = 0;
                    if (!this.isPurchaseOrder) {
                        everyItemDiscountType = item.everyItemDiscountType;
                        if (item.everyItemDiscountType == 1) {
                            everyItemDiscount = item.everyItemDiscount * 0.01;
                        } else {
                            everyItemDiscount = item.everyItemDiscount;
                        }
                    }
                    let insertItem = {
                        itemDescription: item.itemDescription,
                        rate: item.rate,
                        quantity: item.quantity,
                        discount: everyItemDiscount,
                        discountAsPercent: everyItemDiscountType,
                        sortTag: i,
                        syncStatus: item.syncStatus,
                        withholdingAble: everyItemWithholdingStatus,
                        belongToInvoice: belongToInvoiceTag,
                        allExclusiveTaxMoney: item.allExclusiveTaxMoney,
                        allInclusiveTaxMoney: item.allInclusiveTaxMoney,
                        subtotalMoney: item.subtotalMoney,
                        taxRateInfo: item.taxRateInfo.endsWith("&&") ? item.taxRateInfo.substr(0, item.taxRateInfo.length - 2) : item.taxRateInfo,
                        totalMoney: item.everyItemTotalMoney,
                        withholdingMoney: everyItemWithholdingMoney,
                        allTaxMoney: item.totalTaxMoney,
                        taxType: item.taxType,
                        fromClient: 3,
                        innerUUID: item.innerUUID,
                        itemCode: item.itemCode,
                        parentUUID: item.parentUUID,
                        isShowInventory: item.isShowInventory,
                        inventoryNumber: item.inventoryNumber,
                        isShowCost: item.isShowCost,
                        invoiceUUID: this.invoiceUUID,
                        cost: item.cost,
                        unit: item.unit,
                        createdFromTime: item.createdFromTime,
                        timeUUID: item.timeUUID,
                        type: 0,
                        createDate: timest(),
                        accessDate: timest()
                    };
                    return insertItem;
                } else {
                    //保存到item
                    let insertItem = {
                        itemDescription: item.itemDescription,
                        rate: item.rate,
                        quantity: item.quantity,
                        discount: 0,
                        discountAsPercent: 0,
                        sortTag: 0,
                        syncStatus: 0,
                        withholdingAble: 0,
                        belongToInvoice: 0,
                        allExclusiveTaxMoney: 0,
                        allInclusiveTaxMoney: 0,
                        subtotalMoney: 0,
                        taxRateInfo: item.taxRateInfo.endsWith("&&") ? item.taxRateInfo.substr(0, item.taxRateInfo.length - 2) : item.taxRateInfo,
                        totalMoney: 0,
                        withholdingMoney: 0,
                        allTaxMoney: 0,
                        taxType: 0,
                        fromClient: 3,
                        innerUUID: item.innerUUID,
                        itemCode: item.itemCode,
                        parentUUID: item.parentUUID,
                        isShowInventory: item.isShowInventory,
                        inventoryNumber: item.inventoryNumber,
                        isShowCost: item.isShowCost,
                        invoiceUUID: "",
                        cost: item.cost,
                        unit: item.unit,
                        createdFromTime: 0,
                        timeUUID: "",
                        type: 0,
                        createDate: timest(),
                        accessDate: timest()
                    };
                    return insertItem;
                }
            },
            validateDocumentInputs() {
                if (!this.isPurchaseOrder) {
                    const bigDiscountScale = this.bigDiscountType === "1" || this.bigDiscountType === 1 ? 3 : 5;
                    if (!isValidItemDecimal(this.bigDiscount, false, bigDiscountScale)
                        || !isValidItemDecimal(this.shipping.amount, false, 5)) {
                        this.$message.error(this.$t('invoiceCreate.msgInvalidAmount'));
                        return false;
                    }
                }
                for (let index = 0; index < this.itemList.length; index++) {
                    const item = this.itemList[index];
                    if (item.syncStatus === 1) {
                        continue;
                    }
                    if (String(item.unit == null ? '' : item.unit).indexOf('&&') !== -1) {
                        this.$message.error(this.$t('itemCreate.msgInvalidUnit'));
                        return false;
                    }
                    if (!isValidItemDecimal(item.quantity, false, 5)) {
                        this.$message.error(this.$t('itemCreate.msgInvalidInventory'));
                        return false;
                    }
                    if (!isValidItemDecimal(item.rate, true, 4)) {
                        this.$message.error(this.$t('itemCreate.msgInvalidRate'));
                        return false;
                    }
                    if (!this.isPurchaseOrder) {
                        const itemDiscountScale = item.everyItemDiscountType === "1" || item.everyItemDiscountType === 1 ? 3 : 5;
                        if (!isValidItemDecimal(item.everyItemDiscount, false, itemDiscountScale)) {
                            this.$message.error(this.$t('invoiceCreate.msgInvalidAmount'));
                            return false;
                        }
                    }
                }
                return true;
            },
            /**
             * 保存invoice
             * @param flag 100: 退出编辑
             * @param next 路由next方法
             * @returns {Promise<void>}
             */
            async createInvoice(flag, next) {
                if (!this.initialDataLoaded) {
                    return;
                }
                if (!this.validateDocumentInputs()) {
                    return;
                }
                if (flag !== 100 && this.tabIndex === "2" && !validateEmail(this.clientInfo.clientEmail)) {
                    this.$message({
                        type: 'error',
                        message: this.$t('invoiceCreate.msgClientEmailError'),
                        duration: 6000
                    });
                    return;
                }
                if (this.saveRequestPending) {
                    return;
                }
                this.saveRequestPending = true;
                this.pageHaveChange = 0;
                let self = this;
                let itemUUIDArrayKey = "";

                if (this.invoiceUUID === '') {
                    this.invoiceUUID = uuid(null, 37);
                }

                this.loginLoading = true;
                let insertItemArray = [];

                let taxInfoUUIDArrayKey = "";

                for (let i = 0; i < self.itemList.length; i++) {
                    let item = self.itemList[i];

                    let taxInfoList = self.itemList[i].everyTaxInfoList;
                    for (let j = 0; j < taxInfoList.length; j++) {
                        if (taxInfoUUIDArrayKey.indexOf(taxInfoList[j].newInnerUUID) == -1 && taxInfoList[j].newInnerUUID != -1) {
                            taxInfoUUIDArrayKey += taxInfoList[j].newInnerUUID + ",";
                        }
                    }

                    let needCreateItemIndex = 0;
                    if (item.innerUUID === undefined && this.saveNewItemToItem == 1) {
                        //新增的item,需要保存一份到item表,作为商品使用
                        let insertItem = this.addCreateInvoiceItem(item, i, 0);
                        insertItem.innerUUID = uuid(null, 37);
                        insertItemArray.push(insertItem);
                        item.parentUUID = insertItem.innerUUID;
                        needCreateItemIndex = 1;
                    }
                    //这个是保存为invoice的item
                    let insertItem = this.addCreateInvoiceItem(item, i, 1);
                    if (needCreateItemIndex == 1 || item.innerUUID === undefined) {
                        insertItem.innerUUID = uuid(null, 37);
                        item.innerUUID = insertItem.innerUUID;
                    }
                    itemUUIDArrayKey = itemUUIDArrayKey + insertItem.innerUUID + ",";
                    insertItemArray.push(insertItem);
                }

                //遍历payHistory历史的key
                /*let paymentHistoryKey = "";
                for (let i = 0; i < this.originPaymentHistory.length; i++) {
                    paymentHistoryKey += this.originPaymentHistory[i].innerUUID + ",";
                }*/

                let createClient = {};
                if (this.createClientDivStatus === 1) {
                    //默认是修改,1.client修改,2.client创建
                    let clientUpdateOrCreate = 1;
                    if (this.clientInfo.innerUUID === undefined || this.clientInfo.innerUUID === "") {
                        this.clientInfo.innerUUID = uuid(null, 37);
                        clientUpdateOrCreate = 2;
                    }

                    createClient = {
                        name: this.clientInfo.name,
                        clientEmail: this.clientInfo.clientEmail,
                        phone: this.clientInfo.phone,
                        billingAddressLine1: this.clientInfo.billingAddressLine1,
                        billingAddressLine2: this.clientInfo.billingAddressLine2,
                        billingAddressLine3: this.clientInfo.billingAddressLine3,
                        shippingAddressLine1: this.clientInfo.shippingAddressLine1,
                        shippingAddressLine2: this.clientInfo.shippingAddressLine2,
                        shippingAddressLine3: this.clientInfo.shippingAddressLine3,
                        shippingName: this.clientInfo.shippingName,
                        note: this.clientInfo.note,
                        updateOrCreate: clientUpdateOrCreate,
                        innerUUID: this.clientInfo.innerUUID,
                        createDate: timest(),
                        accessDate: timest(),
                        fromClient: 3,
                        isDelete: 0,
                        syncStatus: 0,
                        cell: this.clientInfo.cell,
                        contact: this.clientInfo.contact,
                        fax: this.clientInfo.fax,
                        pager: this.clientInfo.pager,
                        website: this.clientInfo.website,
                        itemDiscount: clientUpdateOrCreate === 2 ? 0 : this.clientInfo.itemDiscount,
                        itemDiscountAsPercent: clientUpdateOrCreate === 2 ? 0 : this.clientInfo.itemDiscountAsPercent,
                    };
                }


                let insertFileList = [];
                let imageUUIDString = "";
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].syncStatus != 1) {
                        imageUUIDString += this.fileList[i].innerUUID + ",";
                    }
                    let tempImage = buildInvoiceImageForRequest(this.fileList[i], i);
                    insertFileList.push(tempImage);
                }

                let paidStatus = 0;
                if (parseFloat(this.paid.toFixed(4)) >= parseFloat(this.$NP.minus(this.totalMarks, this.totalWithholdingMoney.money).toFixed(4))) {
                    paidStatus = 2;
                } else if (parseFloat(this.paid.toFixed(4)) > 0 && parseFloat(this.paid.toFixed(4)) < parseFloat(this.totalMarks.toFixed(4))) {
                    paidStatus = 1;
                }

                let totalInvoiceTaxInforString = "";
                //<!-- key  =====[ "two&&0.3&&0", [ 0.6, 2 ] ] value == [99.89999999999999, 333]
                for (let [key, value] of this.totalInvoiceTaxInfoMap) {
                    var split = key.split('&&');
                    if (split[2] === '0') {
                        totalInvoiceTaxInforString += "";
                    } else {
                        totalInvoiceTaxInforString += this.userSetting.includesLabel + " ";
                    }

                    totalInvoiceTaxInforString += split[0] + " " + parseFloat(split[1] * 100).toFixed(this.userSetting.currencyDecimalPlaces) + '% ';
                    if (this.userSetting.isShowTaxBreakdown === 1) {
                        totalInvoiceTaxInforString += '(' + xiaoshudianfenge(value[1], this.userSetting) + ")";
                    }
                    totalInvoiceTaxInforString += "&&&" + xiaoshudianfenge(value[0], this.userSetting) + "---";
                    totalInvoiceTaxInforString += "";

                }

                for (let i = 0; i < self.taxInfoList.length; i++) {
                    //保证时间是最新的,不然传给ios会有问题
                    self.taxInfoList[i].createDate = timest();
                    self.taxInfoList[i].accessDate = timest();
                    self.taxInfoList[i].updateTime = timest();
                }

                const jobDetailString = serializeJobDetails(this.jobDetailsListList);

                let tempDate = new Date(this.invoiceStartDate);
                const documentRequest = {
                        "itemList": insertItemArray,
                        "userClient": createClient,
                        "payHistoryList": [],
                        "invoiceImageList": insertFileList,
                        "taxInfoList": self.taxInfoList,
                        "invoice": {
                            innerUUID: self.invoiceUUID,
                            comment: self.comment,
                            createDate: timest(),
                            discount: self.isPurchaseOrder ? 0 : (self.bigDiscountType == 0 ? self.bigDiscount : self.bigDiscount / 100),
                            discountAsPercent: self.isPurchaseOrder ? 0 : self.bigDiscountType,
                            dueDate: toTmpTime(new Date(tempDate.setDate(tempDate.getDate() + 30))),
                            emailed: self.emailed,
                            invoiceStartDate: toTmpDateWithCurrentTime(self.invoiceStartDate),
                            num: self.invoiceMaxNumber,
                            shipping: self.isPurchaseOrder ? 0 : ("" == self.shipping.amount ? 0 : self.shipping.amount),
                            shippingDate: self.isPurchaseOrder ? 0 : toTmpTime(self.shipping.shipDate),
                            shippingFOB: self.isPurchaseOrder ? "" : self.shipping.fob,
                            shippingTracking: self.isPurchaseOrder ? "" : self.shipping.shippingTracking,
                            shippingVia: self.isPurchaseOrder ? "" : self.shipping.shipVia,
                            status: self.estimateStatus,
                            syncStatus: 0,
                            terms: 30,
                            type: self.invoiceType,
                            withholdingRate: self.isPurchaseOrder ? 0 : self.userSetting.withHoldingTaxRate,
                            accessDate: timest(),
                            clientUUIDKey: this.clientInfo.innerUUID,
                            billingAddressLine1: this.clientInfo.billingAddressLine1,
                            billingAddressLine2: this.clientInfo.billingAddressLine2,
                            billingAddressLine3: this.clientInfo.billingAddressLine3,
                            shippingAddressLine1: this.clientInfo.shippingAddressLine1,
                            shippingAddressLine2: this.clientInfo.shippingAddressLine2,
                            shippingAddressLine3: this.clientInfo.shippingAddressLine3,
                            shippingName: this.clientInfo.shippingName,
                            itemUUIDArrayKey: itemUUIDArrayKey.endsWith(",") ? itemUUIDArrayKey.substr(0, itemUUIDArrayKey.length - 1) : itemUUIDArrayKey,
                            payhistoryUUIDArrayKey: "",
                            invoiceImageUUIDArrayKey: imageUUIDString.endsWith(",") ? imageUUIDString.substr(0, imageUUIDString.length - 1) : imageUUIDString,
                            updateTime: timest(),
                            allExclusiveTaxMoney: self.invoiceMoneyInfo.allExclusiveTaxMoney,
                            allInclusiveTaxMoney: self.invoiceMoneyInfo.allInclusiveTaxMoney,
                            allTaxMoney: self.invoiceMoneyInfo.allTaxMoney,
                            balanceDueMoney: self.computeBalanceDueMoney,
                            paidMoney: self.paid,
                            paidStatus: paidStatus,
                            subtotalMoney: self.computeSubTotal,
                            //taxMoneyInfo 已删除
                            taxMoneyInfo: "",
                            totalMoney: self.totalMarks,
                            withholdingActive: self.isPurchaseOrder ? 0 : self.userSetting.withHoldingActive,
                            withholdingMoney: self.isPurchaseOrder ? 0 : self.totalWithholdingMoney.money,
                            totalWithholdingItemPrice: self.isPurchaseOrder ? 0 : self.totalWithholdingMoney.totalOriginItemPrice,
                            withholdingTaxName: self.isPurchaseOrder ? "" : self.userSetting.withHoldingTaxName,
                            versionCode: 2,
                            taxInfoUUIDArrayKey: taxInfoUUIDArrayKey.endsWith(",") ? taxInfoUUIDArrayKey.substr(0, taxInfoUUIDArrayKey.length - 1) : taxInfoUUIDArrayKey,
                            emailRecord: "",
                            numPrefix: self.numPrefix,
                            markColor: 0,
                            isReceiptType: 0,
                            totalTaxInforString: totalInvoiceTaxInforString,
                            jobDetails: jobDetailString,
                            //todo isReceiptType没做
                            fromClient: 3,
                            invoiceSignatureUUIDArrayKey: ""
                        },
                    createOrUpdateInvoice: 1
                };
                return this.$axios.post('web_create_invoice', {
                    params: documentRequest
                }).then(response => {
                    if (response.data.errorCode != 0) {
                        this.$message({
                            type: 'error',
                            message: response.data.errorMsg,
                            duration: '1300',
                        });
                        this.loginLoading = false;
                        return;
                    } else {
                        this.documentInitialState = serializeDocumentEditorState(this);
                        //退出保存
                        if (flag === 100) {
                            next();
                        }

                        if (this.tabIndex === "0") {
                            //跳转到创建页面
                            let self = this;
                            this.pageHaveChange = 0;
                            self.$router.push(self.documentListRoute);

                        } else if (this.tabIndex === "1") {
                            //展示PDF
                            //不用随机数的话会有缓存
                            const loginInformation = JSON.parse(localStorage.getItem("loginInformation")).objectData;
                            const previewUrl = new URL('preview_pdf', this.$store.state.requestURL);
                            previewUrl.searchParams.set('invoiceUUID', this.invoiceUUID);
                            previewUrl.searchParams.set('email', loginInformation.email);
                            previewUrl.searchParams.set('userUuid', loginInformation.userUuid);
                            previewUrl.searchParams.set('companyUUID', this.companyUUID);
                            previewUrl.searchParams.set('nowTime', timest());
                            previewUrl.searchParams.set('createType', this.pdfCreateType);
                            previewUrl.searchParams.set('aaa', Math.round(Math.random() * 10));
                            previewUrl.searchParams.set('timeont', moment.tz.guess());
                            this.pdfPreviewUrl = previewUrl.toString();
                        } else if (this.tabIndex === "2") {
                            //发送邮件
                            this.loginLoading = true;
                            let that = this;
                            return this.$axios.post('send_email_to_client', {
                                params: {
                                    invoiceUUID: that.invoiceUUID,
                                    toEmail: that.clientInfo.clientEmail,
                                    subject: that.sendEmail.subject,
                                    copyEmail: that.sendEmail.ccEmail,
                                    secretEmail: that.sendEmail.bccEmail,
                                    content: that.userSetting.emailMessage,
                                    pdfName: that.numPrefix + that.invoiceMaxNumber + ".pdf",
                                    timeont: moment.tz.guess(),
                                    nowTime: timest(),
                                    createType: this.pdfCreateType,
                                    companyUUID: this.companyUUID
                                }
                            }).then(response => {
                                if (response.data.errorCode == 0) {
                                    this.$message({
                                        type: 'info',
                                        message: this.$t('common.sendSuccess'),
                                        duration: 6000
                                    });
                                    that.emailed = 1;
                                }
                                this.loginLoading = false;
                            })
                        }
                    }
                }).finally(() => {
                    this.saveRequestPending = false;
                })
            },
            //打开对话框
            openAddPaymentDialog() {
                if (parseFloat(this.paid.toFixed(4)) >= parseFloat(this.$NP.minus(this.totalMarks, this.totalWithholdingMoney.money).toFixed(4))) {

                    //已经全付款了,不让再添加
                    this.$message.error(this.$t('invoiceCreate.msgMorePaymentThanBalance'));
                    return;
                }
                // this.addPaymentDialog = true;
                // this.payMentAutofocus = true;
            },

            closeClientDialog() {
                this.clientDialogStatus = false;
                this.createClientDivStatus = 1;
                // this.payMentAutofocus = false;
            },

            openClientDialog() {
                this.clientDialogSnapshot = JSON.parse(JSON.stringify(this.clientInfo));
                this.clientDialogPreviousStatus = this.createClientDivStatus;
                this.clientDialogStatus = true;
            },

            cancelClientDialog() {
                this.clientInfo = this.clientDialogSnapshot;
                this.createClientDivStatus = this.clientDialogPreviousStatus;
                this.clientDialogStatus = false;
            },

            deleteChooseClient() {
                this.createClientDivStatus = 0;
                this.clientInfo = createEmptyDocumentClient();
                this.clientDialogStatus = false;
            },

            /*changeFullPayStatusEvent() {
                if (this.paymentObj.fullPayStatus) {
                    //全部支付
                    this.paymentObj.paidMoney = this.$NP.minus(this.totalMarks, this.paid, this.totalWithholdingMoney.money).toFixed(this.userSetting.currencyDecimalPlaces);
                    this.paymentObj.truePaidMoney = this.$NP.minus(this.totalMarks, this.paid, this.totalWithholdingMoney.money);
                    this.paymentObj.isFullPay = 1;
                }
            },*/
            querySearchClientList(queryString, cb) {
                const requestSequence = ++this.clientSearchRequestSequence;
                searchDocumentClients(this.$axios, queryString, this.companyUUID).then(clientList => {
                    if (requestSequence === this.clientSearchRequestSequence) {
                        cb(clientList);
                    }
                }).catch(() => {
                    if (requestSequence === this.clientSearchRequestSequence) {
                        cb([]);
                        this.$message.error(this.$t('invoiceCreate.searchSuggestionsLoadFailed'));
                    }
                });
            },
            handleItemDescriptionArrow(event) {
                if (event.currentTarget.getAttribute('aria-expanded') !== 'true') {
                    event.stopPropagation();
                }
            },
            querySearchItemList(queryString, cb) {
                const requestSequence = ++this.itemSearchRequestSequence;
                searchDocumentItems(this.$axios, queryString, this.companyUUID).then(itemList => {
                    if (requestSequence === this.itemSearchRequestSequence) {
                        cb(itemList);
                    }
                }).catch(() => {
                    if (requestSequence === this.itemSearchRequestSequence) {
                        cb([]);
                        this.$message.error(this.$t('invoiceCreate.searchSuggestionsLoadFailed'));
                    }
                });
            },
            searchClientSelect(item) {
                clientDefaultDiscountForItem(item);
                this.clientInfo.name = item.value;
                this.clientInfo.clientEmail = item.clientEmail;
                this.clientInfo.phone = item.phone;
                this.clientInfo.cell = item.cell;
                this.clientInfo.contact = item.contact;
                this.clientInfo.fax = item.fax;
                this.clientInfo.pager = item.pager;
                this.clientInfo.website = item.website;
                this.clientInfo.billingAddressLine1 = item.billingAddressLine1;
                this.clientInfo.billingAddressLine2 = item.billingAddressLine2;
                this.clientInfo.billingAddressLine3 = item.billingAddressLine3;
                this.clientInfo.shippingName = item.shippingName;
                this.clientInfo.shippingAddressLine1 = item.shippingAddressLine1;
                this.clientInfo.shippingAddressLine2 = item.shippingAddressLine2;
                this.clientInfo.shippingAddressLine3 = item.shippingAddressLine3;
                this.clientInfo.itemDiscount = item.itemDiscount;
                this.clientInfo.itemDiscountAsPercent = item.itemDiscountAsPercent;
                this.clientInfo.innerUUID = item.innerUUID;
                this.clientInfo.note = item.note;
            },
            searchItemSelect(item, index) {
                const defaultDiscount = this.isPurchaseOrder
                    ? {type: 0, value: 0}
                    : clientDefaultDiscountForItem(this.clientInfo);
                this.itemList[index].itemDescription = item.value;
                this.itemList[index].quantity = 1;
                this.itemList[index].everyItemDiscountType = defaultDiscount.type;
                this.itemList[index].everyItemDiscount = defaultDiscount.value;
                if (null == item.rate) {
                    this.itemList[index].rate = 1;
                } else {
                    this.itemList[index].rate = item.rate;
                }
                this.itemList[index].itemCode = item.itemCode;
                this.itemList[index].innerUUID = uuid(null, 37);
                this.itemList[index].parentUUID = item.innerUUID;
                this.itemList[index].isShowInventory = item.isShowInventory;
                this.itemList[index].inventoryNumber = item.inventoryNumber;
                this.itemList[index].isShowCost = item.isShowCost;
                this.itemList[index].cost = item.cost;
                this.itemList[index].unit = item.unit;

                //taxRateInfo
                //6454D20A-6622-4980-85FA-C12CC81E5294:-1&&64FD8243-C228-4DF4-8A7A-6F3C99089325:0.465465&&DD064B56-DE7D-421A-B311-6622A53C4983:0.165456
                //这个item的所有tax选择情况
                let taxRateInfoSplit = String(item.taxRateInfo == null ? '' : item.taxRateInfo).split("&&");
                //当前选择的item的tax集合字段
                let tempTaxInfoList = this.itemList[index].everyTaxInfoList;

                for (let i = 0; i < tempTaxInfoList.length; i++) {
                    let index = 0;
                    for (let j = 0; j < taxRateInfoSplit.length; j++) {
                        if (taxRateInfoSplit[j].indexOf(tempTaxInfoList[i].innerUUID) != -1) {
                            let taxRate = taxRateInfoSplit[j].split(":")[1];
                            if (taxRate != -1) {
                                tempTaxInfoList[i].chooseRate = parseFloat(taxRate);
                            } else {
                                tempTaxInfoList[i].chooseRate = "-1";
                            }
                            index = 1;
                        }
                    }
                    if (index == 0) {
                        tempTaxInfoList[i].chooseRate = "-1";
                    }
                }
            },
            computeItemAfterItemDiscountOriginMoney: function (item) {
                if (this.isPurchaseOrder) {
                    return this.$NP.times(item.quantity, item.rate);
                }
                let itemAfterItemDiscountOriginMoney = 0;
                if (item.everyItemDiscount == undefined || item.everyItemDiscount == '') {
                    itemAfterItemDiscountOriginMoney = this.$NP.times(item.quantity, item.rate);
                } else {
                    if (item.everyItemDiscountType == 1) {
                        //百分比
                        itemAfterItemDiscountOriginMoney = this.$NP.minus(this.$NP.times(item.quantity, item.rate), this.$NP.times(item.quantity, item.rate, item.everyItemDiscount, 0.01));
                    } else if (item.everyItemDiscountType == 0) {
                        //直接减money
                        itemAfterItemDiscountOriginMoney = this.$NP.minus(this.$NP.times(item.quantity, item.rate), parseFloat(item.everyItemDiscount));
                    }
                }
                return itemAfterItemDiscountOriginMoney;
            }
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.documentInitialState !== ''
                && this.documentInitialState !== serializeDocumentEditorState(this)) {
                this.$confirm(this.$t('invoiceCreate.confirmUnsavedChanges'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.createInvoice(100, next);
                    // next();
                }).catch(function (action) {
                    if (action === 'cancel') {
                        next();
                    }
                });
            } else {
                next();
            }
        },
        mounted() {
            this.queryCompanyInfo();
            this.requestURL = getFileUploadUrl(this.$store.state.requestURL);
            this.uploadData.email = JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
        },
        //复杂运算
        computed: {
            invoiceType() {
                if (this.$route.query.type === "2") return 2;
                if (this.$route.query.type === "3") return 3;
                return 1;
            },
            pdfCreateType() {
                return this.invoiceType;
            },
            isPurchaseOrder() {
                return this.invoiceType === 2 || this.invoiceType === 3;
            },
            documentName() {
                if (this.invoiceType === 2) return this.$t('invoiceCreate.purchaseOrder');
                if (this.invoiceType === 3) return this.userSetting.creditMemoLabel;
                return this.userSetting.estimateLabel;
            },
            documentListRoute() {
                if (this.invoiceType === 2) return "/purchaseOrder";
                if (this.invoiceType === 3) return "/creditMemo";
                return "/estimate";
            },
            documentPrefixPlaceholder() {
                if (this.invoiceType === 2) return this.$t('invoiceCreate.placeholderPurchaseOrderPrefix');
                if (this.invoiceType === 3) return this.$t('invoiceCreate.placeholderCreditMemoPrefix');
                return this.$t('invoiceCreate.placeholderEstimatePrefix');
            },
            computeSubTotal: function () {
                let total = 0;
                let me = this;
                for (let i = 0; i < me.itemList.length; i++) {
                    let item = me.itemList[i];
                    total += me.computeItemAfterItemDiscountOriginMoney(item);
                }
                return total;
            },
            computeBalanceDueMoney: function () {
                let totalMark = this.totalMarks;
                let result = this.$NP.minus(totalMark, this.paid, this.totalWithholdingMoney.money);
                // console.log(result);
                if (Number(result.toFixed(this.userSetting.currencyDecimalPlaces)) === 0) {
                    result = 0;
                }
                return result;
            },
            totalMarks: function () {
                //逻辑: 获取每个商品的税
                let total = 0;
                let me = this;
                // 每次税的展示都得重新算
                me.totalInvoiceTaxInfoMap = new Map();
                me.totalWithholdingMoney = {
                    "money": 0,
                    "totalOriginItemPrice": 0
                };
                //先设置为0,保证修改的时候不会把之前的数据叠加
                me.invoiceMoneyInfo.allTaxMoney = 0;
                me.invoiceMoneyInfo.allExclusiveTaxMoney = 0;
                me.invoiceMoneyInfo.allInclusiveTaxMoney = 0;
                //1.遍历每个商品
                for (let i = 0; i < me.itemList.length; i++) {

                    let item = me.itemList[i];

                    if (item.syncStatus == 1) {
                        continue;
                    }

                    let itemPrice = me.computeItemAfterItemDiscountOriginMoney(item);
                    //用于保存数据库

                    //计算总的discount
                    if (!me.isPurchaseOrder && me.computeSubTotal != 0) {
                        if (me.bigDiscountType == 0) {
                            //金额
                            itemPrice = this.$NP.minus(itemPrice, this.$NP.times(this.$NP.divide(itemPrice, me.computeSubTotal), me.bigDiscount));
                        } else {
                            //百分比
                            itemPrice = this.$NP.minus(itemPrice, this.$NP.times(this.$NP.divide(itemPrice, me.computeSubTotal), me.computeSubTotal, this.$NP.divide(me.bigDiscount, 100)));
                        }
                    }

                    // let everyItemTaxCheckList = item.everyItemTaxCheckList;
                    let taxInclusiveRate = 0;
                    let tempUnTaxInclusiveRate = [];
                    item.taxRateInfo = "";
                    item.taxType = 0;

                    //用于保存taxType
                    let haveOffTax = false;
                    let haveNormalTax = false;
                    const taxCalculationFactorMap = buildTaxCalculationFactorMap(me.taxInfoList, item.everyTaxInfoList);
                    //先遍历选中了哪些tax
                    for (let i = 0; i < item.everyTaxInfoList.length; i++) {
                        let taxInfo = item.everyTaxInfoList[i];
                        let taxInclusive = taxInfo.taxInclusive;
                        item.allExclusiveTaxMoney = 0;

                        //查看是否有打开税和保存taxType的值
                        if (taxInfo.chooseRate == undefined || taxInfo.chooseRate === '-1') {
                            //用于保存taxType
                            haveOffTax = true;
                            item.taxRateInfo += taxInfo.newInnerUUID + ":-1&&";
                            continue;
                        } else {
                            // haveOffTax = false;
                            haveNormalTax = true;
                        }

                        //保存数据库
                        item.taxRateInfo += taxInfo.newInnerUUID + ":" + taxInfo.chooseRate + "&&";

                        if (taxInclusive == 1) {
                            //商品未知
                            taxInclusiveRate += taxCalculationFactorMap.get(taxInfo.newInnerUUID);

                            //得算右侧区域的每个in税,先放进去,算出商品原价之后再算////////////////////
                            let key = taxInfo.taxName + "&&" + taxInfo.chooseRate + "&&" + taxInfo.taxInclusive;
                            let taxCalculationFactor = taxCalculationFactorMap.get(taxInfo.newInnerUUID);
                            if (!this.totalInvoiceTaxInfoMap.has(key)) {
                                //第三个是为了标记是这个商品有用的tax,处理的时候记得标记为0.多个商品的时候,可能这个商品用了A税,下个商品还用A税.也可能不用A税
                                this.totalInvoiceTaxInfoMap.set(key, [0, 0, 1, taxCalculationFactor]);
                            } else {
                                let tempValue = this.totalInvoiceTaxInfoMap.get(key);
                                tempValue[2] = 1;
                                tempValue[3] = taxCalculationFactor;
                                this.totalInvoiceTaxInfoMap.set(key, tempValue);
                            }
                            //得算右侧区域的每个in税,先放进去,算出商品原价之后再算////////////////////

                        } else {
                            tempUnTaxInclusiveRate.push(taxInfo);
                        }
                    }
                    if (haveOffTax && haveNormalTax) {
                        item.taxType = 1;
                    } else if (haveOffTax) {
                        item.taxType = 0;
                    } else if (haveNormalTax) {
                        item.taxType = 2;
                    }
                    // include计算: 1+intax1x+intax2x+....=商品价格,解方程,算出商品原价,如果既有in又有非in,那么先算商品价格,再算税
                    // in的税不会造成总价的改变
                    // 如果是多个商品也是一样的, 将所有商品总价算出来,然后解上面的方程,算出原价
                    // 多个商品还需要考虑这个商品有A税,另一个商品没有A税,并且当中可能有的是in还可能是非in
                    // 一个商品多个in 多个商品1个in 多个商品多个in,如果有in,先各自算出自己的原价.然后汇总,计算税费
                    // 这里相当于使用了乘法交换律，所以可以单独的算
                    // 下面一步先算出原价
                    let originItemPrice = this.$NP.divide(itemPrice, (1 + taxInclusiveRate));
                    //用于保存数据库
                    item.allInclusiveTaxMoney = this.$NP.minus(itemPrice, originItemPrice);
                    me.invoiceMoneyInfo.allInclusiveTaxMoney += item.allInclusiveTaxMoney;
                    //如果有in的税,算出原价之后再算用于展示的税////////////////////
                    me.totalInvoiceTaxInfoMap.forEach(function (value) {
                        if (value[2] == 1) {
                            //value的角标0是税的钱,角标1是商品原价的钱
                            value[0] = me.$NP.plus(value[0], me.$NP.times(originItemPrice, value[3]));
                            value[1] = me.$NP.plus(value[1], originItemPrice);
                            value[2] = 0;
                        }
                    });

                    //如果有in的税,算出原价之后再算用于展示的税////////////////////
                    let totalTaxMoney = 0;
                    item.everyItemTotalMoney = itemPrice;
                    for (let i = 0; i < tempUnTaxInclusiveRate.length; i++) {
                        let untaxInfo = tempUnTaxInclusiveRate[i];
                        //计算每个商品的ex税
                        let itemEveryUnIncludeTaxMoney = this.$NP.times(originItemPrice, taxCalculationFactorMap.get(untaxInfo.newInnerUUID));

                        //计算用于在右侧vat区展示的部分////////////////////
                        let key = untaxInfo.taxName + "&&" + untaxInfo.chooseRate + "&&" + untaxInfo.taxInclusive;
                        if (this.totalInvoiceTaxInfoMap.has(key)) {
                            let tempTaxTotalMoneyArray = this.totalInvoiceTaxInfoMap.get(key);
                            tempTaxTotalMoneyArray[0] = this.$NP.plus(tempTaxTotalMoneyArray[0], itemEveryUnIncludeTaxMoney);
                            tempTaxTotalMoneyArray[1] = this.$NP.plus(tempTaxTotalMoneyArray[1], originItemPrice);
                        } else {
                            let valueArray = [];
                            valueArray[0] = itemEveryUnIncludeTaxMoney;
                            valueArray[1] = originItemPrice;
                            this.totalInvoiceTaxInfoMap.set(key, valueArray);
                        }
                        //计算用于在右侧vat区展示的部分////////////////////
                        totalTaxMoney += itemEveryUnIncludeTaxMoney;
                        //用于保存数据库
                        if (item.allExclusiveTaxMoney == undefined) {
                            item.allExclusiveTaxMoney = 0;
                        }
                        item.allExclusiveTaxMoney += itemEveryUnIncludeTaxMoney;
                        item.everyItemTotalMoney += itemEveryUnIncludeTaxMoney;
                    }

                    //确保这个字段不会是undefined
                    if (item.allExclusiveTaxMoney == undefined) {
                        item.allExclusiveTaxMoney = 0;
                    }

                    if (!this.isPurchaseOrder && item.everyItemWithholdingStatus) {
                        //Withholding是所有涉及到的商品原价和*税率.算出来之后再减去商品的税什么的都计算完了再减Withholding
                        item.everyItemWithholdingMoney = this.$NP.times(originItemPrice, me.userSetting.withHoldingTaxRate);
                        me.totalWithholdingMoney.money += item.everyItemWithholdingMoney;
                        me.totalWithholdingMoney.totalOriginItemPrice += originItemPrice;
                    }
                    //计算invoice总价
                    // total += itemPrice + totalTaxMoney - me.totalWithholdingMoney.money;
                    total += this.$NP.plus(itemPrice, totalTaxMoney);
                    //用于保存数据库
                    item.totalTaxMoney = this.$NP.plus(item.allExclusiveTaxMoney, item.allInclusiveTaxMoney);

                    me.invoiceMoneyInfo.allExclusiveTaxMoney += item.allExclusiveTaxMoney;
                    me.invoiceMoneyInfo.allTaxMoney += item.totalTaxMoney;
                    //这里我觉得是ios有问题,为什么不减去ex税的钱,除非想的是算出原价
                    item.subtotalMoney = this.$NP.minus(itemPrice, item.allInclusiveTaxMoney);

                }
                if (!this.isPurchaseOrder) {
                    total = this.$NP.plus(total, this.shipping.amount);
                }
                return total;
            }
        }
    }
</script>
<style>


    body > .el-container {
        margin-bottom: 40px;
    }


    .add_margin_top {
        margin-top: 20px;
    }


    .itemFlex {
        display: flex;
        justify-content: space-between;
    }


    .itemTitle {
        background: #EFEFF4;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 3%;
        font-size: 18px;
    }

    .box {
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }

    .column {
        flex-basis: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .span_margin_button {
        margin-bottom: 10px;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>

<style scoped>


    /deep/ .el-input--suffix .el-input__inner {
        padding-right: 0px;
    }


    /deep/ .el-form--label-top .el-form-item__label {
        padding: 0px;
    }

    /*拉长下拉框,有的地方不需要下拉*/
    /deep/ .el-select-dropdown__wrap {
        max-height: 400px;
    }


    /*消除内容和tab框的距离*/
    /deep/ .el-tabs--border-card > .el-tabs__content {
        padding: 0px;
    }

    .pdf-window {
        display: block;
        height: calc(100vh - 176px);
        min-height: 720px;
    }

    /*消除和下面input的长短位置差异*/
    /deep/ .el-autocomplete {
        display: block;
    }

    /*消除和下面input的长短位置差异*/
    /deep/ .el-form-item {
        margin-bottom: 0px;
    }

    /deep/ .el-input__inner {
        width: 100%;
        border-style: none none solid none;
        border-radius: 0px;
        padding: 0px 0px;
    }

    /deep/ .el-textarea__inner {
        border-style: none none none none;
        resize: none;
        width: 100%;
        border-radius: 0px;
        padding-left: 3%;
        padding-top: 10px;
    }

    /deep/ .el-header {
        background-color: #f7f7f9;
        line-height: 24px;
        font-size: var(--ui-font-page-title);
        padding: 30px var(--ui-page-gutter);
        font-weight: 500;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
    }

    /deep/ .el-main {
        background: white;
    }


    .text_align_right >>> .el-input__inner {
        text-align: right;
    }

    /*.select_padding >>> .el-input__inner {
        width: 100%;
    }*/

    .select_padding {
        width: 100%;
    }

    /deep/ .aaa .el-textarea__inner {
        border-style: none none solid none;
    }

    /deep/ .select_padding .el-input__suffix {
        left: 2%;
        text-align: left;
    }

    /deep/ .paymentDate .el-input__prefix {
        right: 5px;
    }

    .clientSelect >>> .el-input__inner {
        padding-left: 3%;
    }

    .quantityClass >>> .el-input__inner {
        height: 30px;
        color: #3A3A40;
        font-size: var(--responsive-font-14);
        border-bottom-color: #DADDE6;
        transition: border-color 0.18s ease;
    }

    .quantityClass >>> .el-input__inner:focus {
        border-bottom-color: var(--ui-primary);
    }

    .invoice-hover-card {
        background: #FFFFFF;
        box-shadow: 0 3px 12px rgba(31, 42, 68, 0.06);
        transition: box-shadow 0.18s ease;
    }

    .invoice-hover-card:hover {
        box-shadow: 0 8px 20px rgba(31, 42, 68, 0.10);
    }

    .invoice-client-card-body {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 95px;
    }

    .invoice-client-info {
        min-width: 0;
    }

    .invoice-card-actions {
        display: flex;
        flex: 0 0 auto;
        align-items: flex-end;
        justify-content: flex-end;
        gap: 10px;
        margin-right: 24px;
        line-height: 25px;
    }

    .invoice-client-action-button {
        padding-bottom: 0;
    }

    .invoice-item-card {
        background: #FFFFFF;
        box-shadow: 0 3px 12px rgba(31, 42, 68, 0.06);
        transition: box-shadow 0.18s ease;
    }

    .invoice-item-card:hover {
        box-shadow: 0 8px 20px rgba(31, 42, 68, 0.10);
    }

    .invoice-item-card-body {
        padding-top: 14px;
        padding-right: 20px;
        padding-bottom: 10px;
    }

    .invoice-item-description {
        width: 50%;
    }

    .invoice-item-description >>> .el-textarea__inner {
        min-height: 34px;
        color: #34343A;
        font-size: var(--responsive-font-14);
        font-weight: 400;
        border-bottom-color: #DADDE6;
        transition: border-color 0.18s ease;
    }

    .invoice-item-description >>> .el-textarea__inner:focus {
        border-bottom-color: var(--ui-primary);
    }

    .invoice-item-summary {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 16px;
        min-width: 0;
    }

    .invoice-item-inputs {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 0 16px;
        width: 50%;
        min-width: 0;
    }

    .invoice-item-field {
        flex: 0 0 120px;
        width: 120px;
    }

    .invoice-item-code-row {
        width: 288px;
        margin-top: 6px;
    }

    .invoice-item-multiply {
        flex: 0 0 auto;
        color: #50535A;
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 5px;
    }

    .invoice-item-total {
        flex: 0 0 auto;
        color: #3A3A40;
        font-size: 22px;
        font-weight: 400;
        margin-right: 24px;
        margin-bottom: 20px;
        white-space: nowrap;
    }

    .itemDiscountClass >>> .el-input__inner {
        height: 25px;
    }

    .tax-panel {
        padding: 4px 10px;
    }

    .tax-panel-trigger {
        color: #409EFF;
        font-size: 16px;
        font-weight: 400;
        margin-top: 5px;
        padding-left: 0;
    }

    .tax-panel-trigger:hover,
    .tax-panel-trigger:focus {
        color: #409EFF;
    }

    .tax-panel-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 28px;
        min-height: 64px;
    }

    .tax-panel-row + .tax-panel-row {
        border-top: 1px dashed #D8D8DE;
    }

    .tax-panel-label {
        color: #303133;
        font-size: 16px;
        line-height: 22px;
    }

    .tax-panel-checkbox {
        width: 100%;
    }

    .tax-panel-checkbox >>> .el-checkbox__label {
        font-size: 16px;
    }

    .tax-rate-select {
        flex: 0 0 180px;
    }

    .tax-rate-select >>> .el-input__inner {
        height: 36px;
        color: #303133;
        font-size: var(--responsive-font-14);
        text-align: right;
        padding-right: 32px;
    }

    .tax-rate-select >>> .el-input__suffix {
        right: 4px;
    }

    .discount-control {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 0 0 290px;
        gap: 16px;
    }

    .discount-type-group {
        flex: 0 0 auto;
    }

    .discount-type-group >>> .el-radio-button__inner {
        min-width: 48px;
        height: 32px;
        padding: 8px 14px;
        font-size: var(--responsive-font-14);
        line-height: 14px;
    }

    .discount-input {
        flex: 0 0 120px;
        width: 120px;
    }

    .discount-input >>> .el-input__inner {
        height: 32px;
        font-size: var(--responsive-font-14);
        text-align: right;
    }

    .item-delete-text {
        font-size: 16px;
        font-weight: 400;
    }

    .invoice-item-delete-button {
        padding-top: 6px;
        padding-bottom: 0;
        min-width: 64px;
        text-align: right;
    }

    .invoice-item-delete-button:hover .item-delete-text,
    .invoice-item-delete-button:focus .item-delete-text {
        color: #D70015;
    }

    .commentInput >>> .el-textarea__inner {
        padding-left: 0;
    }

    .commentInput {
        display: block;
        margin-bottom: 24px;
    }

    .attachment-card-body {
        justify-content: space-between;
        padding-right: 20px;
    }

    .attachment-card-content {
        display: flex;
        align-items: stretch;
        flex: 1 1 auto;
        max-width: 72%;
        min-width: 0;
    }

    .attachment-thumbnail {
        flex: 0 0 120px;
        width: 120px;
        min-height: 96px;
        border-radius: var(--ui-radius-control);
        overflow: hidden;
        cursor: zoom-in;
    }

    .attachment-thumbnail >>> .el-image__inner {
        display: block;
    }

    .attachment-inputs {
        flex: 1 1 auto;
        min-width: 180px;
    }

    .attachment-delete-button {
        padding-top: 6px;
        padding-right: 0;
    }

    .attachment-delete-text {
        font-size: 16px;
        font-weight: 400;
    }

    .invoice-side-panel >>> .el-divider--horizontal {
        height: 0;
        background-color: transparent;
        border-bottom: 1px solid #d7dadb;
    }

    .sub-title {
        color: var(--ui-text-muted);
        font-size: var(--responsive-font-14);
        font-weight: 400;
        letter-spacing: 0;
    }


</style>
